import PropTypes from "prop-types";

import Stack from "@mui/material/Stack";

import LoadingIcon from "../assets/icons/LoadingIcon";
import { Typography } from "@mui/material";

const LoadingFallback = (props) => {
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      sx={{ ...props.containerSx, height: props.containerSx?.height || "100vh" }}
    >
      <LoadingIcon sx={props.iconSx} />

      {props.message && (
        <Typography variant="h6" sx={{ opacity: props.iconSx?.opacity }}>
          {props.message}
        </Typography>
      )}
    </Stack>
  );
};

LoadingFallback.propTypes = {
  containerSx: PropTypes.object,
  iconSx: PropTypes.object,
  message: PropTypes.string,
};

export default LoadingFallback;
